module.exports = __webpack_public_path__ + "static/media/3.34fa9c4a.png";